import { render } from "./NewArea.vue?vue&type=template&id=9f76ecf0&scoped=true"
import script from "./NewArea.vue?vue&type=script&lang=js"
export * from "./NewArea.vue?vue&type=script&lang=js"

import "./NewArea.vue?vue&type=style&index=0&id=9f76ecf0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\OneDrive\\Cookies BIS\\CookiesBIS\\core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f76ecf0"]])

export default __exports__